export default __webpack_public_path__ + "0b1590cefb85f9de752ac50063b54d31.png";